import React, { useState } from 'react';
import SearchBox from '../../../../components/outline/SearchBox';
import BaseForm from '../../../../components/form/BaseForm';
import ButtonList from '../../../../components/ButtonList';

import {
  SETTLEMENT_PERIOD_SELECT_LIST,
  SETTLEMENT_BY_BRAND_FORM_INIT_STATE,
  SETTLEMENT_BRAND_SEARCH_BOX_SELECT_LIST,
  SETTLEMENT_BRAND_LIST_PRODUCT_MANAGEMENT_TYPE_CHECKBOX_LIST,
  MAXIMUM_NUMBER_OF_SEARCH_BOX_BRAND_ID,
} from '../../constants';
import { SettlementByBrandForm } from '../../types';
import useRouter from '../../../../hooks/common/useRouter';
import { isSettlementByBrandForm } from '../../utils/guards';
import { StyledWrapper } from './styles';
import Select from '../../../../components/input/Select';
import TextArea from '../../../../components/input/TextArea';
import CheckBoxGroup from '../../../../components/input/CheckBoxGroup';
import { numberAndCommaRegExp } from '../../../../regExp/numberAndCommaRegExp';
import { asyncSimpleModal } from '../../../../lib/common';

const SettlementListSearchBox = (): JSX.Element => {
  const router = useRouter();
  const { pathname, query } = router;

  const [form, setForm] = useState<SettlementByBrandForm>(
    isSettlementByBrandForm(query) ? query : SETTLEMENT_BY_BRAND_FORM_INIT_STATE,
  );

  const onClear = (): void => {
    router.push(pathname, {});
  };

  const onSubmit = async (form: SettlementByBrandForm): Promise<void> => {
    if (form.searchType === 'ids' && !numberAndCommaRegExp.test(form.searchText) && form.searchText !== '') {
      await asyncSimpleModal({
        type: 'error',
        title: `브랜드는 ID 숫자만 입력해 주세요`,
        okText: '확인',
        cancelText: '아니오',
      });
      return;
    }

    router.push(pathname, { query: form });
  };

  const setProductManagementTypes = (productManagementTypes: SettlementByBrandForm['productManagementTypes']): void => {
    return setForm((prev) => ({ ...prev, productManagementTypes }));
  };

  const setPeriodType = (periodType: SettlementByBrandForm['periodType']): void => {
    setForm((prev) => ({ ...prev, periodType }));
  };

  const setSearchType = (searchType: SettlementByBrandForm['searchType']): void => {
    setForm((prev) => ({ ...prev, searchType }));
  };

  const setSearchText = (searchText: SettlementByBrandForm['searchText']): void => {
    setForm((prev) => ({ ...prev, searchText }));
  };

  return (
    <StyledWrapper>
      <SearchBox
        className="coupon-list-search-box"
        onSearch={(): void => {
          onSubmit(form);
        }}
        onClear={(): void => {
          onClear();
          setForm(SETTLEMENT_BY_BRAND_FORM_INIT_STATE);
        }}
      >
        <BaseForm
          label={
            <div className="inline-form">
              <Select
                list={SETTLEMENT_BRAND_SEARCH_BOX_SELECT_LIST}
                value={form.searchType}
                onChange={(value: SettlementByBrandForm['searchType']): void => {
                  setSearchType(value);
                }}
              />
            </div>
          }
          content={
            <div className="inline-form">
              <TextArea
                value={form.searchText}
                maxLength={MAXIMUM_NUMBER_OF_SEARCH_BOX_BRAND_ID}
                onChange={(value: string): void => {
                  setSearchText(value.trim());
                }}
                placeholder="복수 검색 (“,” 로 구분)"
                onPressEnter={(): void => {
                  onSubmit(form);
                }}
              />
            </div>
          }
        />

        <BaseForm
          label="상품 타입"
          content={
            <CheckBoxGroup
              onChange={(value: SettlementByBrandForm['productManagementTypes']): void => {
                setProductManagementTypes(value);
              }}
              value={form.productManagementTypes}
              list={SETTLEMENT_BRAND_LIST_PRODUCT_MANAGEMENT_TYPE_CHECKBOX_LIST}
            />
          }
        />

        <BaseForm
          label="정산 주기 타입"
          content={
            <ButtonList
              current={form.periodType}
              list={SETTLEMENT_PERIOD_SELECT_LIST}
              onClick={(option: (typeof SETTLEMENT_PERIOD_SELECT_LIST)[number]): void => {
                setPeriodType(option.id);
              }}
            />
          }
        />
      </SearchBox>
    </StyledWrapper>
  );
};

export default SettlementListSearchBox;
